var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Dimmer, Grid, Header, Input, Loader, Menu, Message, Modal, Select, Table } from "semantic-ui-react";
import { CatalogMode, getWithAuthn } from "../RequestHelpers";
import { RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { CompatibleLabels } from "../kit/rna-fish/HcrAmplifierForm";
import { MetaCatalogLoader } from "../kit/Catalog";
import { encoderAmplifierCatalogFor } from "../kit/secondary-if/SecondaryIfCatalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import UploadFileModal from "./UploadFileModal";
import { displayLocalTimestamp } from "./AllOrdersPage";
import ReactTable from "react-table";
var EncoderTrackingPage = /** @class */ (function (_super) {
    __extends(EncoderTrackingPage, _super);
    function EncoderTrackingPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EncoderTrackingPage.prototype.render = function () {
        var renderer = function (catalog) {
            return React.createElement(EncoderTrackingContent, { catalog: catalog });
        };
        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: renderer });
    };
    return EncoderTrackingPage;
}(React.PureComponent));
export default EncoderTrackingPage;
var EncoderTrackingContent = /** @class */ (function (_super) {
    __extends(EncoderTrackingContent, _super);
    function EncoderTrackingContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTable = function (resp) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Encoder"),
                        React.createElement(Table.HeaderCell, null, "10 \u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "50 \u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "100 \u00B5L aliquots"))),
                React.createElement(Table.Body, null, resp.encoders.map(function (entry, index) {
                    return React.createElement(Table.Row, { key: index },
                        React.createElement(Table.Cell, null,
                            entry.primarySpecies.displayName,
                            "-",
                            entry.hcrAmplifier.id,
                            " ",
                            _this.editEncoderEntry(entry, _this.props.catalog)),
                        React.createElement(Table.Cell, null, entry.ul10Aliquots),
                        React.createElement(Table.Cell, null, entry.ul50Aliquots),
                        React.createElement(Table.Cell, null, entry.ul100Aliquots));
                })));
        };
        _this.renderEventsTable = function (resp) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, "Events"),
                React.createElement(ReactTable, { columns: [
                        {
                            id: 'name',
                            Header: 'User',
                            accessor: function (e) { return e.user.name; }
                        },
                        {
                            id: 'type',
                            Header: 'Type',
                            accessor: function (e) { return e.type; }
                        },
                        {
                            id: 'primarySpecies',
                            Header: 'Primary Species',
                            accessor: function (e) { return e.primarySpecies.displayName; }
                        },
                        {
                            id: 'hcrAmplifier',
                            Header: 'Amplifier',
                            accessor: function (e) { return e.hcrAmplifier.id; }
                        },
                        {
                            id: 'msg',
                            Header: 'Message',
                            accessor: function (e) { return e.msg; },
                            Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                        },
                        {
                            id: 'createdAt',
                            Header: 'Created',
                            accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                        },
                    ], data: resp.encoderEvents, defaultPageSize: 50, defaultSorted: [{
                            id: 'createdAt'
                        }], minRows: 1 }));
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/inventory/encoders')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.inputNewAliquots = function (catalog) {
            var renderEncoderModal = function (props) {
                return React.createElement(EncoderModal, __assign({ catalog: catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Input new aliquots' }) },
                React.createElement(Modal.Header, null, "Input new aliquots"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEncoderModal, successMessage: 'New aliquots inputted' })));
        };
        _this.editEncoderEntry = function (encoderEntry, catalog) {
            var renderEncoderModal = function (props) {
                return React.createElement(EncoderModal, __assign({ encoderEntry: encoderEntry, catalog: catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'edit', size: 'mini' }) },
                React.createElement(Modal.Header, null, "Edit encoder inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEncoderModal, successMessage: 'Inventory updated' })));
        };
        _this.uploadInventory = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload inventory' }) },
                React.createElement(Modal.Header, null, "Upload inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/admin/inventory/encoders/upload-current-inventory" })));
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    EncoderTrackingContent.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'non-header-portion' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            React.createElement(Menu, null,
                React.createElement(Menu.Item, null, this.uploadInventory()),
                React.createElement(Menu.Item, null, this.inputNewAliquots(this.props.catalog))),
            this.state.response && this.renderTable(this.state.response),
            this.state.response && this.renderEventsTable(this.state.response));
    };
    EncoderTrackingContent.prototype.componentDidMount = function () {
        this.loadData();
    };
    return EncoderTrackingContent;
}(React.PureComponent));
var EncoderModal = /** @class */ (function (_super) {
    __extends(EncoderModal, _super);
    function EncoderModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onPrimarySpeciesChange = function (_, data) {
            var species = _this.props.catalog.secondaryIfCatalog.encoder.primarySpecies.find(function (p) { return p.id === data.value; });
            if (species === undefined) {
                throw new RangeError("Could not find species " + data.value);
            }
            // The new species may not allow the current amplifier; fall back to its default if so. Update
            // both fields in one setState so render never sees a species/amplifier mismatch (which throws).
            var newCatalog = encoderAmplifierCatalogFor(_this.props.catalog.secondaryIfCatalog, species);
            var stillValid = newCatalog.channels.some(function (a) { return a.hcrAmplifier.id === _this.state.hcrAmplifier.id; });
            var nextAmplifier = stillValid ? _this.state.hcrAmplifier : newCatalog.defaultChannel.hcrAmplifier;
            _this.setState({
                primarySpecies: species,
                hcrAmplifier: nextAmplifier
            });
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var catalog = encoderAmplifierCatalogFor(_this.props.catalog.secondaryIfCatalog, _this.state.primarySpecies).channels
                .find(function (a) {
                return a.hcrAmplifier.id === valStr;
            });
            if (catalog === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            _this.setState({
                hcrAmplifier: catalog.hcrAmplifier
            });
        };
        _this.onEncodeALotNumberChange = function (_, data) {
            var str = data.value;
            _this.setState({ encodeALotNumber: str });
        };
        _this.onEncodeBLotNumberChange = function (_, data) {
            var str = data.value;
            _this.setState({ encodeBLotNumber: str });
        };
        _this.onUl10AliquotsChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ ul10Aliquots: num });
        };
        _this.onUl50AliquotsChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ ul50Aliquots: num });
        };
        _this.onUl100AliquotsChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ ul100Aliquots: num });
        };
        _this.onReasonChange = function (_, data) {
            _this.setState({ reason: data.value });
        };
        _this.submit = function () {
            var _a;
            if (_this.props.encoderEntry == null) {
                _this.props.postRequest("/admin/inventory/encoders/add-new-aliquots", {
                    primarySpeciesId: (_a = _this.state.primarySpecies) === null || _a === void 0 ? void 0 : _a.id,
                    hcrAmplifierId: _this.state.hcrAmplifier.id,
                    encodeALotNumber: _this.state.encodeALotNumber,
                    encodeBLotNumber: _this.state.encodeBLotNumber,
                    ul10Aliquots: _this.state.ul10Aliquots,
                    ul50Aliquots: _this.state.ul50Aliquots,
                    ul100Aliquots: _this.state.ul100Aliquots
                });
            }
            else {
                _this.props.postRequest("/admin/inventory/encoders/update-existing-entry/id/" + encodeURIComponent(_this.props.encoderEntry.id), {
                    ul10Aliquots: _this.props.encoderEntry.ul10Aliquots === _this.state.ul10Aliquots ? null : _this.state.ul10Aliquots,
                    ul50Aliquots: _this.props.encoderEntry.ul50Aliquots === _this.state.ul50Aliquots ? null : _this.state.ul50Aliquots,
                    ul100Aliquots: _this.props.encoderEntry.ul100Aliquots === _this.state.ul100Aliquots ? null : _this.state.ul100Aliquots,
                    reason: _this.state.reason.trim()
                });
            }
        };
        _this.state = {
            primarySpecies: props.encoderEntry ? props.encoderEntry.primarySpecies : undefined,
            hcrAmplifier: props.encoderEntry ? props.encoderEntry.hcrAmplifier : encoderAmplifierCatalogFor(props.catalog.secondaryIfCatalog, undefined).defaultChannel.hcrAmplifier,
            encodeALotNumber: "",
            encodeBLotNumber: "",
            ul10Aliquots: props.encoderEntry ? props.encoderEntry.ul10Aliquots : 0,
            ul50Aliquots: props.encoderEntry ? props.encoderEntry.ul50Aliquots : 0,
            ul100Aliquots: props.encoderEntry ? props.encoderEntry.ul100Aliquots : 0,
            reason: ""
        };
        return _this;
    }
    EncoderModal.prototype.render = function () {
        var _a;
        var catalog = encoderAmplifierCatalogFor(this.props.catalog.secondaryIfCatalog, this.state.primarySpecies).channels;
        var encoderOptions = this.props.catalog.secondaryIfCatalog.encoder.primarySpecies.map(function (p) { return ({
            text: p.displayName,
            value: p.id
        }); });
        var amplifierDropdownText = function () {
            return catalog.map(function (a) {
                return {
                    text: React.createElement(React.Fragment, null,
                        a.hcrAmplifier.id,
                        React.createElement("span", { className: "description" }, a.hcrAmplifier.id.startsWith("X") && React.createElement(CompatibleLabels, { labels: a.labels }))),
                    value: a.hcrAmplifier.id
                };
            });
        };
        return React.createElement(Grid, { columns: 2 },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/primarySpecies', errors: this.props.state.errors, labelContent: 'Primary Species' },
                        React.createElement(Select, { name: 'primary-species', className: "label-dropdown", disabled: this.props.encoderEntry != null, onChange: this.onPrimarySpeciesChange, placeholder: 'Select...', options: encoderOptions, value: (_a = this.state.primarySpecies) === null || _a === void 0 ? void 0 : _a.id, search: true }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifier', errors: this.props.state.errors, labelContent: 'Amplifier' },
                        React.createElement(Select, { className: "label-dropdown", disabled: this.props.encoderEntry != null, value: this.state.hcrAmplifier.id, onChange: this.onAmplifierChange, options: amplifierDropdownText(), name: 'amp-hcr-amplifier' })))),
            this.props.encoderEntry == null &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/encodeALotNumber', labelContent: 'Encoder A Lot Number' },
                            React.createElement(Input, { onChange: this.onEncodeALotNumberChange, placeholder: 'Encoder A Lot Number', type: "text", value: this.state.encodeALotNumber }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/encodeBLotNumber', labelContent: 'Encoder B Lot Number' },
                            React.createElement(Input, { onChange: this.onEncodeBLotNumberChange, placeholder: 'Encoder B Lot Number', type: "text", value: this.state.encodeBLotNumber })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/ul10Aliquots', labelContent: '10 µL aliquots' },
                        React.createElement(Input, { onChange: this.onUl10AliquotsChange, placeholder: '0', type: "number", value: this.state.ul10Aliquots }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/ul50Aliquots', labelContent: '50 µL aliquots' },
                        React.createElement(Input, { onChange: this.onUl50AliquotsChange, placeholder: '0', type: "number", value: this.state.ul50Aliquots }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/ul100Aliquots', labelContent: '100 µL aliquots' },
                        React.createElement(Input, { onChange: this.onUl100AliquotsChange, placeholder: '0', type: "number", value: this.state.ul100Aliquots })))),
            this.props.encoderEntry != null &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 },
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/reason', labelContent: 'Reason for adjustment' },
                            React.createElement(Input, { fluid: true, onChange: this.onReasonChange, placeholder: 'e.g. Miscount found during audit; lots pulled for recall', type: "text", value: this.state.reason })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success || this.state.primarySpecies === undefined
                            || (this.props.encoderEntry != null && this.state.reason.trim() === ''), icon: 'plus', label: this.props.encoderEntry ? 'Save update' : 'Add new encoder aliquots', labelPosition: 'left', onClick: this.submit, positive: true }))));
    };
    return EncoderModal;
}(React.PureComponent));
//# sourceMappingURL=EncoderTrackingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EncoderTrackingPage.js
// module id = 1474
// module chunks = 0